module.exports = __webpack_public_path__ + "static/img/xyqp-03.536b61fe.jpg";